function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/warehouse/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const warehouseRoutes = [
  {
    path: '/warehouse/dashboard',
    component: view('Dashboard'),
    name: 'warehouse.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/sales-order',
    component: view('SalesOrder'),
    name: 'warehouse.sales-order',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'warehouse.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default warehouseRoutes
